import React, { useRef, useEffect, useCallback, useState} from 'react';
import Colors from "components/Colors.js";
import {connect} from 'react-redux';
import Resolution from 'engine/Resolution.js';
const colors = new Colors();

// 6 rows row 0 is [0,1] row 1 is [2,3] row 2 is [4,5] row 3 is [6,7] row 4 [8, 9] , row 5 [10, 11]
const Triangle = ({sequencerEngine, row, part, step=0}) => { 
    const onMouseDown = useCallback(() => {
        let resolution = new Resolution(Math.pow(2, 2 + Math.floor(part/2)), part % 2 === 1);
        sequencerEngine.resolution = resolution;
        sequencerEngine.sequenceRolling = true;
        sequencerEngine.trackRolling = true;
    }, [sequencerEngine, part]);

    const onMouseUp = useCallback(() => {
        sequencerEngine.sequenceRolling = false;
        sequencerEngine.trackRolling = false;
    }, [sequencerEngine, part]);

    let triggered = useRef(false);
    let track = useRef(undefined);

    let notesTriggered = new Set();
    let noteToTracks = {};
    let isPart = part === 8 * (((4 * Math.floor(step / 4)) % 32) / 32.0);
    if (sequencerEngine) { 
        for (let sub of sequencerEngine.subSequences) {
            for (let track of sub.tracks) {
                let _notesTriggered = track.notesTriggered || {};
                for (let note in _notesTriggered) {
                    note = mod(note, 12);
                    notesTriggered.add(note);
                    if (!noteToTracks[note]) {
                        noteToTracks[note] = [];
                    }
                    noteToTracks[note].push(track);
                }
            }
       }
    }
    let start = row*2;
    let end = row*2 + 1;
    let className = "triangle";
    if ((notesTriggered.has(start) || notesTriggered.has(end))) {
        let _t1 = noteToTracks[start] || [];
        let _t2 = noteToTracks[end] || [];
        let _tracks = [... _t1, ..._t2].map(x => colors.getColorForTrack(x));
        if (isPart) {
            triggered.current = true;
            track.current = _tracks[part % _tracks.length];
            className += " triggered";
        }
    } else {
        if (isPart && step % 4 === 0) {
            triggered.current = false;
        }
    }
    let style = {};
    if (triggered.current) {
        className += " old-trigger";

        if (track.current !== undefined) {
            style.borderBottomColor = track.current;
            // className += " track-" + track.current;
        } else {
            className += " track-0";
        }
    }
    return (
        <div onMouseDown={onMouseDown} onMouseUp={onMouseUp} style={style} className={className}>
        </div>);
}

const mapStateToProps = (state, props) => {
  return {
      step: props.sequencerEngine && props.sequencerEngine.trackStep
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

const mod = (x,n) => {
    return ((x%n)+n)%n;
};
export default connect(mapStateToProps, mapDispatchToProps)(Triangle);
